module.exports = __webpack_public_path__ + "static/media/time_with_no_position.c392fabb.svg";